"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-input", {
    staticClass: "filter-item",
    staticStyle: {
      width: "200px"
    },
    attrs: {
      placeholder: "Name"
    },
    nativeOn: {
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleFilter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.name,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "name", $$v);
      },
      expression: "listQuery.name"
    }
  }), _c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "140px"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.sort,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "sort", $$v);
      },
      expression: "listQuery.sort"
    }
  }, _vm._l(_vm.sortOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "success",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      disabled: _vm.showVerifyButton,
      type: "primary",
      icon: "el-icon-check"
    },
    on: {
      click: _vm.verifyAvtar
    }
  }, [_vm._v(" " + _vm._s("Verify Avatar") + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      disabled: _vm.showRejectButton,
      type: "warning",
      icon: "el-icon-close"
    },
    on: {
      click: _vm.rejectAvtar
    }
  }, [_vm._v(" " + _vm._s("Reject Avatar") + " ")])], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.sortChange,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "selection",
      width: "80",
      align: "center",
      label: "ID",
      prop: "id"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Name",
      prop: "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("enabled", {
          model: {
            value: scope.row.enabled,
            callback: function ($$v) {
              _vm.$set(scope.row, "enabled", $$v);
            },
            expression: "scope.row.enabled"
          }
        }), _vm._v(" " + _vm._s(scope.row.name) + " "), scope.row.employeesRole ? _c("div", [_vm._v(" ( " + _vm._s(scope.row.employeesRole.name) + " ) ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Code",
      prop: "code"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.code) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "RMLocation",
      prop: "rmLocation"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.rmLocation.name) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Avatar",
      prop: "avatar"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-image", {
          staticStyle: {
            width: "100px",
            height: "100px"
          },
          attrs: {
            src: scope.row.avatar.concat("-md"),
            fit: "fill",
            "preview-src-list": [scope.row.avatar.concat("-lg")]
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: _vm.$t("table.createdDate"),
      width: "180px",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm._f("moment")(scope.row.updatedTimestamp, "MMMM Do YYYY, hh:mm a"),
            placement: "top"
          }
        }, [_c("span", {
          staticStyle: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm._f("moment")(scope.row.updatedTimestamp, "from")))])])];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;